import React from 'react'
import { Alert, Box } from '@mui/material'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import ContactDetailHost from '../../components/contacts/ContactDetailHost'
import type { MeResponse } from '../../api/me'
import useContactsDetailStore from '../../store/contactsDetail'
import { usePageTitle } from '../../components/common/PageTitleContext'

type OutletContext = { me: MeResponse }

const ContactDetailPage: React.FC = () => {
  const { contactId } = useParams<{ contactId: string }>()
  const contactIdNumber = Number(contactId)
  const { me } = useOutletContext<OutletContext>()
  const stationId = me.stations[0]?.id ?? 0
  const isAdmin = me.user?.roles?.includes('admin') ?? false
  const navigate = useNavigate()

  const contactName = useContactsDetailStore(
    React.useCallback(
      (state) => (Number.isFinite(contactIdNumber) ? state.byId[contactIdNumber]?.data?.contact.name ?? null : null),
      [contactIdNumber],
    ),
  )

  usePageTitle(contactName ?? 'Contact', { align: 'center' })

  if (!Number.isFinite(contactIdNumber) || contactIdNumber <= 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">Invalid contact selected.</Alert>
      </Box>
    )
  }

  return (
    <Box sx={{ px: { xs: 1.5, sm: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
      <ContactDetailHost
        stationId={stationId}
        contactId={contactIdNumber}
        isAdmin={isAdmin}
        onMergedRedirect={(toContactId) => navigate(`/inbox/contacts/${toContactId}`)}
        onDeletedRedirect={() => navigate('/inbox/contacts')}
      />
    </Box>
  )
}

export default ContactDetailPage
